import AppDocumentsIndex from "./document.vue";
import AppDocumentsList from "./list/list.vue";
import AppDocumentsItem from "./item/item.vue";

const routes = [
  {
    path: "/document",
    component: AppDocumentsIndex,
    meta: {
      auth: {
        roles: "document.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "document.index",
        component: AppDocumentsList,
        meta: {
          auth: {
            roles: "document.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "document.create",
        component: AppDocumentsItem,
        meta: {
          auth: {
            roles: "document.create",
            redirect: { name: "document.index" }
          }
        }
      },
      {
        path: ":id",
        name: "document.edit",
        component: AppDocumentsItem,
        meta: {
          auth: {
            roles: "document.update",
            redirect: { name: "document.index" }
          }
        }
      }
    ]
  }
];

export default routes;
